import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';

import { withStyles } from '@material-ui/core/styles';
import Grid from '@material-ui/core/Grid';

import Section, { SectionHeader, SectionTitle, SectionBody } from 'components/common/Section';
import CheckboxField from 'components/fields/CheckboxField';
import Button from 'components/common/Button';
import IconPen from 'components/icons/IconPen';
import Menu from 'components/common/Menu';
import DeleteMenu from 'components/common/DeleteMenu';

import { deleteFacility } from 'redux/modules/facilities';

import splitLongWords from 'utils/splitLongWords';

import FacilitiesListItemInformation from './FacilitiesListItemInformation';
import FacilitiesListItemSchedule from './FacilitiesListItemSchedule';

const styles = () => ({
  iconPen: {
    width: 16,
    height: 16,
    marginRight: 7,
  },
  button: {
    verticalAlign: 'top',
    '& + &': {
      marginLeft: 16,
    },
  },
  facilityLogo: {
    width: 60,
    height: 'auto',
    maxWidth: '100%',
    verticalAlign: 'middle',
    marginRight: 8,
  },
  buttons: {
    display: 'flex',
    flexWrap: 'nowrap',
  },
});

class FacilitiesListItem extends Component {
  constructor(props) {
    super(props);

    this.state = {
      anchorEl: null,
    };

    this.onMenuClose = this.onMenuClose.bind(this);
    this.onDeleteButtonClick = this.onDeleteButtonClick.bind(this);
    this.onRemoveCancel = this.onRemoveCancel.bind(this);
    this.onRemoveSubmit = this.onRemoveSubmit.bind(this);
  }

  onMenuClose() {
    this.setState({ anchorEl: null });
  }

  onDeleteButtonClick(event) {
    this.setState({
      anchorEl: event.currentTarget,
    });
  }

  onRemoveCancel() {
    this.setState({ anchorEl: null });
  }

  onRemoveSubmit() {
    this.props.actions.deleteFacility({
      ID: this.props.facility.ID,
    });
    this.setState({ anchorEl: null });
  }

  render() {
    const { facility, account, onlyFacility, classes } = this.props;
    const { anchorEl } = this.state;
    const open = Boolean(anchorEl);
    return (
      <Section>
        <SectionHeader>
          <SectionTitle>
            {(facility.Image && facility.Image.ID) &&
              <img
                className={classes.facilityLogo}
                src={`${facility.Image['File Url']}${facility.Image['File Name']}`}
              />
            }
            {splitLongWords(facility['Company Info']['Company Name'])}
          </SectionTitle>
          <div className={classes.buttons}>
            <Button
              onClick={this.onDeleteButtonClick}
              className={classes.button}
              variant="raised"
              color="primary"
              aria-label="Remove"
              aria-owns={open ? `${facility.ID}-facility-remove-menu` : null}
              aria-haspopup="true"
              disabled={onlyFacility
                || account.Roles.filter(item =>
                  item.Name === 'Master Administrator' || item.Name === 'Administrator' || item.Name === 'Manager').length === 0}
            >
              Delete
            </Button>
            <Menu
              id={`${facility.ID}-facility-remove-menu`}
              anchorEl={anchorEl}
              open={open}
              onClose={this.onMenuClose}
              list={false}
            >
              <DeleteMenu
                text="Are you sure you want to delete this facility?"
                onCancel={this.onRemoveCancel}
                onSubmit={this.onRemoveSubmit}
              />
            </Menu>
            <Button
              className={classes.button}
              variant="raised"
              href={`/settings/business/facilities/${facility.ID}`}
              disabled={account.Roles.filter(item =>
                item.Name === 'Master Administrator' || item.Name === 'Administrator' || item.Name === 'Manager').length === 0}
            >
              <IconPen className={classes.iconPen} />
              Edit
            </Button>
          </div>
        </SectionHeader>
        <SectionBody>
          <Grid
            container
            spacing={24}
          >
            <Grid
              item
              xs={12}
              md={6}
            >
              <FacilitiesListItemInformation {...facility} />
            </Grid>
            <Grid
              item
              xs={12}
              md={6}
            >
              <FacilitiesListItemSchedule schedule={facility['Work Schedule']} />
            </Grid>
          </Grid>
          <Grid
            container
            spacing={24}
          >
            <Grid item>
              <CheckboxField
                label="Observes daylight saving"
                id={`${facility.ID}-observes-daylight-saving`}
                input={{
                  name: `${facility.ID}-observes-daylight-saving`,
                  value: facility['Company Address'] && facility['Company Address']['Observes Daylight Saving']
                    ? facility['Company Address']['Observes Daylight Saving'] : false,
                  onChange: () => {},
                }}
                meta={{
                  touched: false,
                  active: false,
                }}
              />
            </Grid>
          </Grid>
        </SectionBody>
      </Section>
    );
  }
}

FacilitiesListItem.propTypes = {
  facility: PropTypes.shape({
    ID: PropTypes.number.isRequired,
    'Work Schedule': PropTypes.arrayOf(PropTypes.shape({
      ID: PropTypes.number,
    })),
  }).isRequired,
  onlyFacility: PropTypes.bool,
  actions: PropTypes.shape({
    deleteFacility: PropTypes.func.isRequired,
  }).isRequired,
  account: PropTypes.shape({
    Roles: PropTypes.arrayOf(PropTypes.shape({
      Name: PropTypes.string.isRequired,
    })).isRequired,
  }).isRequired,
  classes: PropTypes.shape({
    iconPen: PropTypes.string.isRequired,
    button: PropTypes.string.isRequired,
  }).isRequired,
};

FacilitiesListItem.defaultProps = {
  onlyFacility: false,
};

const mapStateToProps = store => ({
  account: store.account,
});

const mapDispatchToProps = dispatch => ({
  actions: bindActionCreators({ deleteFacility }, dispatch),
});

export default connect(mapStateToProps, mapDispatchToProps)(
  withStyles(styles)(FacilitiesListItem),
);



// WEBPACK FOOTER //
// ./src/components/settings/FacilitiesList/FacilitiesListItem.js